var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cts_box"},[_vm._m(0),_c('router-link',{staticClass:"link_txt",attrs:{"to":{name: 'UsersCustomerRank'}}},[_vm._v("複眼経済塾からの休塾・退塾について")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"min_ttl"},[_c('span',[_vm._v("複眼経済塾からの休塾・退塾はこちらからお手続きください。")])])
}]

export { render, staticRenderFns }